import React, { useState } from "react";
import { useGetInvationInfoQuery } from "../../lib/redux/services/Api";
import { useCreateChatMutation } from "../../lib/redux/services/sections/ChatAndNotification";
import Gmail from "../../assets/icons/gmail.svg";
import Whatsapp from "../../assets/icons/whatsapp.svg";
import LogoIcon from "../../assets/icons/logoIcon.svg";
import useClipBoard from "../../hooks/useClipBoard";
import { reset } from "../../lib/redux/slices/leagueSlice";
import { useGetDictionary } from "../../hooks/useGetDictionary";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { toastMessage } from "../../utils/utils";
import Loader from "../skeletons/Loader";
import { closeShareModel } from "../../lib/redux/slices/controlSlice";
import { useGetPlayersForBookingQuery } from "../../lib/redux/services/sections/Booking";
import SelectPlayerBox from "../booking/SelectPlayerBox";
import Button from "./Button";
import { DictionaryType } from "../../types";

type Props = {
  inviteLink: {
    link: string;
    id: number;
    type: string;
  };
  withAddPlayersButton?: boolean;
  addPlayerAction?: any;
  onCloseAction?: any;
};
type FormType = {
  player: number;
};
function ShareModalContent({
  inviteLink,
  withAddPlayersButton = false,
  addPlayerAction,
  onCloseAction,
}: Props) {
  console.log(inviteLink);

  const { data, isSuccess, isLoading, isError, isFetching } =
    useGetInvationInfoQuery({ id: inviteLink.id, type: inviteLink.type });

  const [createChat] = useCreateChatMutation();
  const [shareType, setShareType] = React.useState<
    "email" | "whatsapp" | "chat" | null
  >(null);
  const { copyText } = useClipBoard();
  const { inputs, coaches }: DictionaryType = useGetDictionary();

  const dispatch = useDispatch();
  const { control, setValue, getValues } = useForm<FormType>({});
  const navigate = useNavigate();
  const [playerEmail, setPlayerEmail] = useState<string>("");
  const generateShareMassage = (isWhatsapp: boolean = false) => {
    if (isError) return inviteLink.link;
    if (
      ["event", "league", "academy", "tournament"].includes(inviteLink.type)
    ) {
      return `You've been invited to join a ${data?.data?.type_label} in ${data?.data?.club?.name}.\n\n${isWhatsapp ? "" : "📅"} ${data?.data?.date || data?.data?.start_date}  ${data?.data?.end_date ? ` - ${data?.data?.end_date}` : ""}\n${isWhatsapp ? "" : "⏰"} ${data?.data?.start_time} - ${data?.data?.end_time}\n${isWhatsapp ? "" : "📍"} ${data?.data?.club?.name}\n\n${isWhatsapp ? "" : "✅"} Confirmed List:\n${new Array(5)
      .fill(0)
      .map((_, i) => {
        if (data?.data?.players[i]) {
          return `${isWhatsapp ? "" : "🔘"} ${i + 1}. ${data?.data?.players[i]?.player_name} ${data?.data?.players[i]?.level}`;
        } else {
          return `${isWhatsapp ? "" : "⚪"} ${i + 1}. Empty Slot`;
        }
      })
      .join("\n")}\n\n${inviteLink.link}`;
    } else {
      return `You've been invited to join a ${data?.data?.type_label} in ${data?.data?.court?.name} court.\n\n${isWhatsapp ? "" : "📅"} ${data?.data?.date} (${data?.data?.start_time})\n\nPlayers:\n${new Array(data?.data?.number_of_players || 4)
      .fill(0)
      .map((_, i) => {
        if (data?.data?.players[i]) {
          return `${isWhatsapp ? "" : "🔘"} ${i + 1}. ${data?.data?.players[i]?.player_name}`;
        } else {
          return `${isWhatsapp ? "" : "⚪"} ${i + 1}. Empty Slot`;
        }
      })
      .join("\n")}\n\n${inviteLink.link}`;
    }
  };
  const handleChat = async (id: number) => {
    try {
      await toast.promise(
        createChat(id)
          .unwrap()
          .then((res) => {
            console.log(res);

            navigate("/chat/" + res.data, {
              state: {
                msg: `${inviteLink.link}`,
              },
            });
          }),
        toastMessage(),
      );
    } catch (error) {}
  };
  if (isLoading || isFetching) {
    return (
      <div className="h-full w-full min-h-[200px] grid place-content-center">
        <Loader />
      </div>
    );
  }
  return (
    <>
      <div className="flex gap-2 items-center justify-center">
        <p>Share Link With: </p>
        <div className="flex gap-4 items-center ">
          <img
            loading="lazy"
            src={LogoIcon}
            alt=""
            width={100}
            height={100}
            onClick={() => {
              setShareType("chat");
            }}
            className="cursor-pointer"
          />
        </div>
        <div className="flex gap-4 items-center ">
          <img
            loading="lazy"
            src={Gmail}
            alt=""
            width={50}
            height={50}
            onClick={() => {
              setShareType("email");
            }}
            className="cursor-pointer"
          />
        </div>
        <div className="flex gap-4 items-center ">
          <img
            loading="lazy"
            src={Whatsapp}
            alt=""
            width={50}
            height={50}
            onClick={() => {
              

                 window.open(
                `https://wa.me/?text=${encodeURIComponent(generateShareMassage(true) ||inviteLink.link)}`,
                `_blank`,
              );
            }}
            className="cursor-pointer"
          />
        </div>
      </div>
      {(shareType === "email" || shareType === "chat") && (
        <div className="w-full flex-1 flex flex-col gap-2 items-start justify-start">
          <label className="block text-sm mb-2 text-primary dark:text-white whitespace-nowrap">
            {inputs.player_name}
            <span className="text-red-500">*</span>
          </label>
          <div className="w-full">
            <Controller
              name={`player`}
              control={control}
              rules={{ required: false }}
              render={({ field }) => (
                <SelectPlayerBox
                  isCustomOption={true}
                  field={field}
                  setValue={setValue}
                  requestFn={useGetPlayersForBookingQuery}
                  name={`player`}
                  onChange={(selected: {
                    id: number;
                    name: string;
                    price: number;
                  }) => {
                    // @ts-ignore only
                    setPlayerEmail(selected?.email);
                    return field.onChange(selected ? selected.id : null);
                  }}
                />
              )}
            />
          </div>
        </div>
      )}
      <p
        className="text-primary dark:text-white font-bold cursor-pointer text-center text-lg"
        onClick={() => {
          copyText(isError ? inviteLink?.link : generateShareMassage(), () => {
            toast.success("share massage copied successfully");
          });
        }}
      >
        Copy Share Massage
      </p>
      <div className="mt-6 flex  items-center justify-center gap-4 w-full">
        <button
          className="border-primary border rounded-full w-full p-2 font-bold text-xl py-4"
          onClick={async () => {
            if (shareType === "chat" && getValues("player")) {
              await handleChat(getValues("player"));
            }

            if (shareType === "email") {
              window.open(
                `mailto:${playerEmail}?subject=You're%20Invited!&body=${encodeURIComponent(generateShareMassage() || inviteLink.link)}`,
                `_blank`,
              );
            }
            onCloseAction && onCloseAction();
            dispatch(closeShareModel());
          }}
        >
          ok
        </button>
        {withAddPlayersButton && (
          <Button
            customeStyle="bg-primary text-white w-full dark:bg-primaryYellow dark:text-primary rounded-full text-lg py-4"
            text={coaches.add_players}
            width="max-w-[400px] w-full"
            onClick={addPlayerAction}
          />
        )}
      </div>
    </>
  );
}

export default ShareModalContent;
